import api from './config'

import type { User } from '@/types/user'

export interface CreateParams {
  user: {
    email: string
    password: string
    marketing_consent?: boolean
    terms_accepted: boolean
    attribution_attributes: {
      utm_source: string | null
      utm_medium: string | null
      utm_campaign: string | null
      utm_term?: string | null
      referrer: string | null
    }
  }
}

export interface UpdateParams {
  user: {
    language?: string
  }
}

interface CreateResponse {
  user: User
  token: string
}

interface ShowResponse {
  user: User
}

const usersAPI = {
  show: async () => {
    const response = await api.get<ShowResponse>('/user')

    return { status: response.status, data: response.data }
  },
  create: async (data: CreateParams) => {
    const response = await api.post<CreateResponse>('/user', data)
    return response.data
  },

  destroy: async () => {
    const response = await api.delete('/user')
    return response.data
  },

  update: async (data: UpdateParams) => {
    const response = await api.patch<ShowResponse>('/user', data)
    return response.data
  },
}

export default usersAPI